// https://github.com/hvianna/audioMotion-analyzer
import AudioMotionAnalyzer from "../vendor/audioMotion-analyzer";

const options = {
    barSpace: 0.12,
    bgAlpha: 0,
    fftSize: 4096,
    fillAlpha: 0,
    lineWidth: 3,
    loRes: false,
    lumiBars: false,
    maxDecibels: -30,
    maxFreq: 8000,
    minDecibels: -90,
    minFreq: 500,
    mode: 3,
    overlay: true,
    radial: false,
    reflexAlpha: 0.15,
    reflexBright: 1,
    reflexFit: true,
    reflexRatio: 0,
    showBgColor: true,
    showFPS: false,
    showLeds: false,
    showPeaks: false,
    showScale: false,
    showScaleY: false,
    smoothing: 0.9,
    spinSpeed: 0
};

const gradiantOptions = {
    name: 'apple',
    bgColor: '#000',
    colorStops: [{pos: .1667, color: '#61bb46'}, {pos: .3333, color: '#fdb827'}, {
        pos: .5, color: '#f5821f'
    }, {pos: .6667, color: '#e03a3e'}, {pos: .8333, color: '#963d97'}, {pos: 1, color: '#009ddc'}],
    disabled: false
}

export var createAudioMotionSpectrum = (player) => {
    if (player.audioMotion === null) {
        player.audioMotion = new AudioMotionAnalyzer(document.getElementById('player-image'), options);
        player.audioMotion.registerGradient('apple', gradiantOptions);
        player.audioMotion.setOptions({gradient: 'apple'});
        player.audioMotion.connectAudio(player.player.getInternalPlayer());
    } else if (player.audioMotion.audioSource.mediaElement !== player.player.getInternalPlayer()) {
        player.audioMotion.switchConnectionAudio(player.player.getInternalPlayer());
    }
}

export var activeSpectrum = function (player, url) {
    if (!url) {
        url = player.state.display;
    }
    let result = false;
    let imageName = url.split('/')[url.split('/').length - 1];
    if (player.state.spectrum && (imageName.includes('background') || imageName.includes('defaultImage') || url.includes('player_sales_logo'))) {
        result = true;
    }
    return result;
}
